module.exports = __webpack_public_path__ + "static/img/6.58e9ef5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/5/4/eng/6.png
// module id = 7E8q
// module chunks = 0